import AUTH_ROUTES from './AuthRoutes';
import PUBLIC_ROUTES from './PublicRoutes';
import OTHER_ROUTES from './OtherRoutes';

export default { AUTH_ROUTES, PUBLIC_ROUTES, OTHER_ROUTES };
